// extracted by mini-css-extract-plugin
export default {"header":"MonitorPage_header__bHf8r","controls":"MonitorPage_controls__4inkJ"};